import React from 'react';
import { faHandshake } from '@fortawesome/pro-regular-svg-icons/faHandshake';
import {
  ELEMENT_TYPE,
  type DocumentElement as DocumentElementType,
} from '@eaco/forms-core';
import EntityPicker from './EntityPicker';
import { ENTITY_KINDS, customerSnapshot } from './entityKinds';
import { DOCUMENT_ELEMENT_CUSTOMERS_QUERY } from './queries';

const CustomerPicker: React.FC<{ element: DocumentElementType }> = ({
  element,
}) => (
  <EntityPicker
    element={element}
    query={DOCUMENT_ELEMENT_CUSTOMERS_QUERY}
    collectionField="documentElementCustomers"
    icon={faHandshake}
    iconColour="#4b5bd6"
    defaults={{
      label: 'Customer',
      placeholder: 'Search for a customer...',
    }}
    rowToSnapshot={customerSnapshot}
    contextSpec={ENTITY_KINDS[ELEMENT_TYPE.customer].contextSpec}
  />
);

export default CustomerPicker;
